<template>
  <div class="reference-value-toggle">
    <div
      class="reference-value-toggle__header"
      :class="{ 'reference-value-toggle__header--opened': valuesOpened }"
      @click="toggleRefValue"
    >
      <div
        v-if="isNewApiFormat"
        class="reference-value-toggle__header--new-layout"
      >
        <h4>
          <md-tooltip>
            {{ 'Metodologia: ' + methodology || 'N/A' }}
          </md-tooltip>
          {{ 'Metodologia: ' + methodology || 'N/A' }}
        </h4>
        <span>
          <md-tooltip>
            <div class="flex-column">
              <template v-for="(part, index) in formatTextToArray(ntoDisplayText, '/')">
                <span
                  v-if="part.isSpace"
                  :key="`tooltip-space-${index}`"
                  class="space"
                ></span>
                <span
                  v-else
                  :key="`tooltip-text-${index}`"
                >
                  {{ part.text }}
                </span>
              </template>
            </div>
          </md-tooltip>

          {{ 'Execução: ' + ntoDisplayText }}
        </span>
      </div>

      <h4 v-else>
        <md-tooltip v-if="ntoDisplayText">
          <div class="flex-column">
            <template v-for="(part, index) in formatTextToArray(ntoDisplayText, '/')">
              <span
                v-if="part.isSpace"
                :key="`tooltip-space-${index}`"
                class="space"
              ></span>
              <span
                v-else
                :key="`tooltip-text-${index}`"
              >
                {{ part.text }}
              </span>
            </template>
          </div>
        </md-tooltip>
        {{ ntoDisplayText || methodology }}
      </h4>
      <svg-loader
        src="/static/images/site/dropdown-arrow.svg"
        class="reference-value-toggle__arrow"
      />
    </div>
    <template v-if="valuesOpened && !isNewApiFormat">
      <div class="reference-value-toggle__content">
        <div class="reference-value-toggle__content--line">
          <div>
            <p class="title-bold">Método</p>
            <p>{{ referenceValues.data.method }}</p>
          </div>
          <div>
            <p class="title-bold">Valor de referência</p>
            <div>
              <p v-html="formatResponseText(referenceValues.data.value)" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="valuesOpened && isNewApiFormat">
      <template v-if="referenceValues.criticism && referenceValues.criticism.length > 0">
        <div class="reference-value-toggle__content">
          <div class="reference-value-toggle__content--line">
            <div>
              <p class="title-bold">Data versão máscara</p>
            </div>
            <div class="reference-value-toggle__date-action">
              <p>{{ formatDate(dateUpdated) }}</p>
              <button
                v-if="profile && isNewApiFormat"
                class="btn-primary reference-value-toggle__mask-btn"
                aria-label="Visualizar máscara de laudo desta versão"
                @click.stop="openMaskForCurrentVersion"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="bottom"
                >
                  Visualizar máscara desta versão
                </md-tooltip>
                <md-icon md-src="/static/images/icon-eye-alt.svg" />
              </button>
            </div>
          </div>

          <div
            class="reference-value-toggle__content--line"
            v-for="(criticism, criticismIndex) in referenceValues.criticism"
            :key="`criticism-${criticismIndex}-${criticism.id || criticismIndex}`"
          >
            <div class="criticisms-cols criticisms-cols--criticism-name box-copy">
              <p class="title-bold">LINHAS DE RESULTADO</p>
              <div class="criticism-content">
                <span>{{ criticism.name }}</span>
                <ButtonCopy :text-to-copy="criticism.name" />
              </div>
            </div>
            <div class="criticisms-cols criticisms-cols--unit-measure box-copy">
              <p class="title-bold">UNIDADE DE MEDIDA</p>
              <div class="criticism-content">
                <span>{{ criticism.unitMeasure || '' }}</span>
                <ButtonCopy :text-to-copy="criticism.unitMeasure || ''" />
              </div>
            </div>
            <div class="criticisms-cols criticisms-cols--reference-value box-copy">
              <p class="title-bold">METODOLOGIA</p>
              <div class="criticism-content">
                <span>{{ criticism.methodology || '' }}</span>
              </div>

              <hr style="margin: 12px 0; border-color: #7f1a54" />

              <p class="title-bold">VALOR DE REFERÊNCIA</p>
              <div class="criticism-content">
                <div>
                  <p
                    v-if="
                      !criticism.referenceValue || criticism.referenceValue.trim() === ''
                    "
                  ></p>
                  <p v-else>
                    <template
                      v-for="(part, index) in formatTextToArray(criticism.referenceValue)"
                    >
                      <span
                        v-if="part.isSpace"
                        :key="`criticism-${criticismIndex}-space-${index}`"
                        class="space"
                      ></span>
                      <span
                        v-else
                        :key="`criticism-${criticismIndex}-text-${index}`"
                      >
                        {{ part.text != null && part.text !== '' ? part.text : '' }}
                      </span>
                    </template>
                  </p>
                </div>
                <ButtonCopy
                  :text-to-copy="
                    'Metodologia: ' +
                    (criticism.methodology || '') +
                    '/ Valor de referência: ' +
                    (criticism.referenceValue || '')
                  "
                />
              </div>
            </div>
          </div>
        </div>

        <template v-if="versionsToShow.length > 0">
          <div
            v-for="(versionGroup, groupIndex) in versionsToShow"
            :key="'version-group-' + groupIndex"
            class="reference-value-toggle__version"
          >
            <template v-if="isVersionExpanded(groupIndex)">
              <div class="reference-value-toggle__content">
                <div class="reference-value-toggle__content--line">
                  <div>
                    <p class="title-bold">Data versão máscara</p>
                  </div>
                  <div class="reference-value-toggle__date-action">
                    <p>{{ formatDate(versionGroup[0].dtUpdated) }}</p>
                    <button
                      v-if="profile && isNewApiFormat"
                      class="btn-primary reference-value-toggle__mask-btn"
                      aria-label="Visualizar máscara de laudo desta versão"
                      @click.stop="openMaskForVersionGroup(versionGroup)"
                    >
                      <md-tooltip
                        md-delay="400"
                        md-direction="bottom"
                      >
                        Visualizar máscara desta versão
                      </md-tooltip>
                      <md-icon md-src="/static/images/icon-eye-alt.svg" />
                    </button>
                  </div>
                </div>

                <div
                  v-for="(criticism, criticismIndex) in getMergedCriticismForVersion(
                    versionGroup
                  )"
                  :key="`version-group-${groupIndex}-criticism-${criticismIndex}-${
                    criticism.id || criticismIndex
                  }`"
                  class="reference-value-toggle__content--line"
                >
                  <div
                    class="criticisms-cols criticisms-cols--criticism-name box-copy"
                    :class="{ 'criticisms-cols--modified': criticism.isModified }"
                  >
                    <p class="title-bold">LINHAS DE RESULTADO</p>
                    <div class="criticism-content">
                      <span>{{ criticism.name }}</span>
                      <ButtonCopy :text-to-copy="criticism.name" />
                    </div>
                  </div>
                  <div
                    class="criticisms-cols criticisms-cols--unit-measure box-copy"
                    :class="{ 'criticisms-cols--modified': criticism.isModified }"
                  >
                    <p class="title-bold">UNIDADE DE MEDIDA</p>
                    <div class="criticism-content">
                      <span>{{ criticism.unitMeasure || '' }}</span>
                      <ButtonCopy :text-to-copy="criticism.unitMeasure || ''" />
                    </div>
                  </div>
                  <div
                    class="criticisms-cols criticisms-cols--reference-value box-copy"
                    :class="{ 'criticisms-cols--modified': criticism.isModified }"
                  >
                    <p class="title-bold">METODOLOGIA</p>
                    <div class="criticism-content">
                      <span>{{ criticism.methodology || '' }}</span>
                    </div>

                    <hr style="margin: 12px 0; border-color: #7f1a54" />

                    <p class="title-bold">VALOR DE REFERÊNCIA</p>
                    <div class="criticism-content">
                      <div>
                        <p
                          v-if="
                            !criticism.referenceValue ||
                            criticism.referenceValue.trim() === ''
                          "
                        ></p>
                        <p v-else>
                          <template
                            v-for="(part, partIndex) in formatTextToArray(
                              criticism.referenceValue
                            )"
                          >
                            <span
                              v-if="part.isSpace"
                              :key="`version-group-${groupIndex}-criticism-${criticismIndex}-space-${partIndex}`"
                              class="space"
                            ></span>
                            <span
                              v-else
                              :key="`version-group-${groupIndex}-criticism-${criticismIndex}-text-${partIndex}`"
                            >
                              {{ part.text != null && part.text !== '' ? part.text : '' }}
                            </span>
                          </template>
                        </p>
                      </div>
                      <ButtonCopy
                        :text-to-copy="
                          'Metodologia: ' +
                          (criticism.methodology || '') +
                          '/ Valor de referência: ' +
                          (criticism.referenceValue || '')
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div
              class="reference-value-toggle__version-toggle"
              @click="toggleVersionExpanded(groupIndex)"
            >
              <span>
                {{
                  isVersionExpanded(groupIndex)
                    ? 'Fechar versão anterior'
                    : 'Ver alteração anterior'
                }}
              </span>
              <svg-loader
                v-if="isVersionExpanded(groupIndex)"
                :key="`arrow-up-${groupIndex}`"
                src="../../../../static/images/site/arrow-down.svg"
                class="reference-value-toggle__arrow-up"
              />
              <svg-loader
                v-else
                :key="`arrow-down-${groupIndex}`"
                src="../../../../static/images/site/arrow-down.svg"
              />
            </div>
          </div>
        </template>

        <div
          v-if="hasMoreVersions"
          class="reference-value-toggle__footer"
          @click="showNextVersion"
        >
          <span>Ver alteração anterior</span>
          <svg-loader src="../../../../static/images/site/arrow-down.svg" />
        </div>

        <div
          v-if="hasMultipleExpandedVersions"
          class="reference-value-toggle__footer reference-value-toggle__footer--close"
          @click="closeAllVersions"
        >
          <span>Fechar versões</span>
          <svg-loader
            src="../../../../static/images/site/arrow-down.svg"
            class="reference-value-toggle__arrow-up"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import Moment from 'moment'
import ButtonCopy from '@/components/common/buttonComponent/ButtonCopy.vue'

export default {
  name: 'ReferenceValueToggle',
  components: {
    ButtonCopy,
  },
  props: {
    referenceValues: {
      type: Object,
      required: true,
    },
    rollbackLaudasa: {
      type: Boolean,
      default: false,
    },
    useNewLayout: {
      type: Boolean,
      default: false,
    },
    forceLegacyFormat: {
      type: Boolean,
      default: false,
    },
    profile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valuesOpened: false,
      currentVersionIndex: 0,
      expandedVersions: {},
    }
  },
  computed: {
    isNewApiFormat() {
      if (this.forceLegacyFormat) {
        return false
      }
      if (!this.useNewLayout) {
        return false
      }
      return (
        this.referenceValues &&
        (this.referenceValues.dateUpdated ||
          this.referenceValues.methodology ||
          this.referenceValues.unitMeasure ||
          this.referenceValues.executationNto)
      )
    },

    dateUpdated() {
      if (this.isNewApiFormat) {
        return this.referenceValues.dateUpdated
      }
      return null
    },

    methodology() {
      if (this.isNewApiFormat) {
        return this.referenceValues.methodology || ''
      }
      return this.referenceValues.data ? this.referenceValues.data.method || '' : ''
    },

    unitMeasure() {
      if (this.isNewApiFormat) {
        return this.referenceValues.unitMeasure || ''
      }
      return this.referenceValues.data ? this.referenceValues.data.unitMeasure || '' : ''
    },

    referenceValue() {
      if (this.isNewApiFormat) {
        return this.referenceValues.referenceValue || ''
      }
      return this.referenceValues.data ? this.referenceValues.data.value || '' : ''
    },

    ntoDisplayText() {
      if (
        this.isNewApiFormat &&
        this.referenceValues.executationNto &&
        this.referenceValues.executationNto.length > 0
      ) {
        return this.referenceValues.executationNto.map(nto => nto.name).join('/')
      }
      return this.referenceValues.executionNto
    },

    criticismNames() {
      if (
        this.isNewApiFormat &&
        this.referenceValues.criticism &&
        this.referenceValues.criticism.length > 0
      ) {
        const uniqueNames = [...new Set(this.referenceValues.criticism.map(c => c.name))]
        return uniqueNames.join('; ')
      }
      return ''
    },

    hasVersions() {
      return (
        this.isNewApiFormat &&
        this.referenceValues.versions &&
        this.referenceValues.versions.length > 0
      )
    },

    groupedVersions() {
      if (!this.hasVersions) return []

      const versions = [...this.referenceValues.versions]
      const groups = []
      let currentGroup = []
      let baseTime = null

      versions.forEach(version => {
        const versionTime = new Date(version.dtCreated).getTime()

        if (!baseTime) {
          baseTime = versionTime
          currentGroup.push(version)
        } else {
          const diffMinutes = Math.abs(versionTime - baseTime) / (1000 * 60)

          if (diffMinutes <= 2) {
            currentGroup.push(version)
          } else {
            if (currentGroup.length > 0) {
              groups.push([...currentGroup])
            }
            currentGroup = [version]
            baseTime = versionTime
          }
        }
      })

      if (currentGroup.length > 0) {
        groups.push(currentGroup)
      }

      return groups
    },

    hasMoreVersions() {
      return (
        this.groupedVersions.length > 0 &&
        this.currentVersionIndex < this.groupedVersions.length
      )
    },

    versionsToShow() {
      if (this.groupedVersions.length === 0) return []
      return this.groupedVersions.slice(0, this.currentVersionIndex)
    },

    hasExpandedVersions() {
      return Object.values(this.expandedVersions).some(isExpanded => isExpanded)
    },

    hasMultipleExpandedVersions() {
      return (
        Object.values(this.expandedVersions).filter(isExpanded => isExpanded).length > 1
      )
    },
  },
  watch: {
    isNewApiFormat: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.emitDataIfNewFormat()
        }
      },
    },
  },
  mounted() {
    this.emitDataIfNewFormat()
  },
  updated() {
    this.emitDataIfNewFormat()
  },
  methods: {
    emitDataIfNewFormat() {
      if (this.isNewApiFormat && !this._hasEmitted) {
        const data = this.getComponentData()
        this.$emit('register-new-format-data', data)
        this._hasEmitted = true
      }
    },
    getComponentData() {
      return {
        isNewApiFormat: this.isNewApiFormat,
        methodology: this.methodology,
        ntoDisplayText: this.ntoDisplayText,
        dateUpdated: this.dateUpdated,
        criticisms: this.referenceValues.criticism || [],
        unitMeasure: this.unitMeasure,
        referenceValue: this.referenceValue,
        executationNto: this.referenceValues.executationNto || [],
        versions: this.referenceValues.versions || [],
      }
    },
    toggleRefValue() {
      this.valuesOpened = !this.valuesOpened
      if (!this.valuesOpened) {
        this.currentVersionIndex = 0
        this.expandedVersions = {}
      }
    },
    showNextVersion() {
      if (this.hasMoreVersions) {
        this.currentVersionIndex++
        this.$set(this.expandedVersions, this.currentVersionIndex - 1, true)
      }
    },
    toggleVersionExpanded(versionIndex) {
      const currentState = this.expandedVersions[versionIndex]
      if (currentState) {
        this.$set(this.expandedVersions, versionIndex, false)
      } else {
        this.$set(this.expandedVersions, versionIndex, true)
      }
    },
    isVersionExpanded(versionIndex) {
      return !!this.expandedVersions[versionIndex]
    },

    closeAllVersions() {
      this.expandedVersions = {}
      this.currentVersionIndex = 0
    },

    getMergedCriticismForVersion(versionGroup) {
      if (
        !this.referenceValues.criticism ||
        this.referenceValues.criticism.length === 0
      ) {
        return []
      }

      const mergedCriticism = JSON.parse(JSON.stringify(this.referenceValues.criticism))

      // Build two maps: by criticism id AND by criticism name.
      // version.id is the version record's own PK (not the criticism id),
      // but version.name matches criticism.name — use that as the primary key.
      // The snapshot format (version.criticism array) is also handled.
      const byId = {}
      const byName = {}

      const push = (map, key, value) => {
        if (key == null) return
        if (!map[key]) map[key] = []
        map[key].push(value)
      }

      versionGroup.forEach(version => {
        if (version.criticism && version.criticism.length > 0) {
          // Snapshot format: nested criticism array
          version.criticism.forEach(c => {
            const entry = { ...c, dtCreated: version.dtCreated }
            push(byId, c.id, entry)
            push(byName, c.name, entry)
          })
        } else {
          // Individual record format
          push(byId, version.id, version)
          push(byName, version.name, version)
        }
      })

      const keepMostRecent = map => {
        Object.keys(map).forEach(key => {
          map[key].sort(
            (a, b) => new Date(b.dtCreated).getTime() - new Date(a.dtCreated).getTime()
          )
          map[key] = map[key][0]
        })
      }
      keepMostRecent(byId)
      keepMostRecent(byName)

      mergedCriticism.forEach((criticism, index) => {
        // Prefer id match; fall back to name match
        const versionData = byId[criticism.id] || byName[criticism.name]
        if (versionData) {
          mergedCriticism[index] = {
            ...mergedCriticism[index],
            ...versionData,
            id: criticism.id, // preserve original criticism id
            isModified: true,
          }
        }
      })

      return mergedCriticism
    },
    formatDate(date) {
      if (!date) {
        return ''
      }

      let dateTime = Moment.utc(date)

      if (!dateTime.isValid()) {
        return ''
      }

      const formattedDate = dateTime.format('DD/MM/YYYY')
      const formattedTime = dateTime.format('HH:mm:ss')

      return formattedDate + ' às ' + formattedTime
    },
    formatResponseText(text, character) {
      if (text && character) {
        return text.replace(new RegExp(character, 'g'), '<span class="space"></span>')
      } else if (text) {
        return text.replace(/\n/g, '<span class="space"></span>')
      }
    },
    formatTextToArray(text, character = '\n') {
      if (!text || text.trim() === '') return [{ text: '', isSpace: false }]

      const parts = []
      const splitChar = character || '\n'
      const segments = text.split(splitChar)

      segments.forEach((segment, index) => {
        if (segment) {
          parts.push({ text: segment, isSpace: false })
        }
        if (index < segments.length - 1) {
          parts.push({ text: '', isSpace: true })
        }
      })

      return parts.length > 0 ? parts : [{ text: '', isSpace: false }]
    },
    getVersionDateCreated(version) {
      return version.dtCreated || ''
    },
    getVersionMethodology(version) {
      return version.methodology || ''
    },
    getVersionUnitMeasure(version) {
      return version.unitMeasure || ''
    },
    getVersionReferenceValue(version) {
      return version.referenceValue || ''
    },
    getVersionCriticismNames(version) {
      if (version.name) {
        return version.name
      }
      if (version.criticism && version.criticism.length > 0) {
        const uniqueNames = [...new Set(version.criticism.map(c => c.name))]
        return uniqueNames.join('; ')
      }
      return ''
    },
    getVersionCriticisms(version) {
      return version.criticism || []
    },
    openMaskForCurrentVersion() {
      this.$emit('open-version-mask', {
        criticisms: this.referenceValues.criticism || [],
        methodology: this.referenceValues.methodology || '',
      })
    },
    openMaskForVersionGroup(versionGroup) {
      const criticisms = this.getMergedCriticismForVersion(versionGroup)

      // Reconstruct the historical NTO-level methodology from the merged criticisms.
      // The backend generates the NTO methodology as unique per-criticism methodologies
      // sorted by length (longest first) and joined with " | ".
      // Example: criticisms with ["Diazo","Diazo","Cálculo"] → "Cálculo | Diazo"
      const seen = new Set()
      const uniqueMethodologies = []
      criticisms.forEach(c => {
        const m = c.methodology || ''
        if (m && !seen.has(m)) {
          seen.add(m)
          uniqueMethodologies.push(m)
        }
      })
      uniqueMethodologies.sort((a, b) => b.length - a.length)
      const versionMethodology =
        uniqueMethodologies.length > 0
          ? uniqueMethodologies.join(' | ')
          : this.referenceValues.methodology || ''

      this.$emit('open-version-mask', {
        criticisms,
        methodology: versionMethodology,
      })
    },
  },
}
</script>

<style lang="scss">
.reference-value-toggle {
  background-color: #f5f5f5;
  border-radius: 6px;
  padding: 12px 16px;
  margin-top: 12px;

  h4 {
    width: 96%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    &--opened {
      padding-bottom: 12px;

      .md-icon {
        transform: rotate(180deg);
      }
    }

    &--new-layout {
      width: 96%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      span {
        font-size: 12px;
        color: #7a7a7a;
      }
    }

    .md-icon {
      margin: 0;
      width: 18px;
      min-width: 18px;
      transition: all 0.3s ease;

      path {
        fill: #7a7a7a;
      }
    }
  }

  &__date-action {
    display: flex;
    align-items: center;
    gap: 8px;

    p {
      flex: 1;
    }
  }

  &__mask-btn {
    flex-shrink: 0;
    height: 28px !important;
    width: 28px;
    min-width: 28px !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    .md-icon {
      width: 16px;
      min-width: 16px;
      margin: 0;
      color: #fff;
    }
  }

  &__content {
    border-top: 1px solid #c4c4c4;
    padding-top: 12px;
    margin-bottom: 12px;

    &--line {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      gap: 8px;

      &:first-child {
        margin-top: 0;
      }

      > div {
        &:first-child {
          flex: 1;
        }

        &:nth-child(2) {
          flex: 1;
        }
      }

      p {
        margin: 0 0 10px !important;
      }

      .criticisms-cols {
        background: #ffffff;
        padding: 12px;
        border-radius: 8px;
        flex: inherit !important;

        .title-bold {
          font-size: 10px !important;
        }

        .criticism-content {
          display: flex;
          align-items: flex-start;
          gap: 8px;

          > span,
          > div {
            flex: 1;
          }
        }
      }
    }
  }

  .box-copy {
    position: relative;

    &:hover {
      background: rgba(0, 0, 0, 0.24);

      button {
        opacity: 1;
        display: block;
        width: 20px;
        height: 20px;

        img {
          width: 14px;
        }
      }
    }

    button {
      position: absolute;
      opacity: 0;
      display: none;
      top: 50%;
      right: 4px;
      transform: translateY(-50%);
    }
  }

  &__content {
    &--line {
      .criticisms-cols {
        &--criticism-name {
          width: 30%;
        }

        &--unit-measure {
          width: 12%;
        }

        &--reference-value {
          flex: 1 !important;
        }
      }
    }
  }

  &__version {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 2px solid #e0e0e0;
    background-color: #fafafa;
    border-radius: 4px;
    padding: 12px;

    .reference-value-toggle__content {
      border-top: none;
      margin-bottom: 0;
      padding-top: 0;
    }
  }

  &__version-toggle {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin-top: 12px;

    span {
      font-size: 16px;

      &:hover {
        text-decoration: underline;
      }
    }

    .md-icon {
      margin: 0;
      color: #7a7a7a;
      width: 18px;
      min-width: 18px;
      transition: all 0.3s ease;
    }
  }

  &__arrow-up {
    transform: rotate(180deg);
  }

  .criticisms-cols--modified {
    background-color: rgba(127, 26, 84, 0.08) !important;
    color: #000000 !important;

    .title-bold,
    span,
    p {
      font-weight: 500;
      color: #000000 !important;
    }
  }

  &__footer--close {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;

    span {
      font-size: 16px;
      font-weight: 600;
      color: #7f1a54;

      &:hover {
        text-decoration: underline;
      }
    }

    .md-icon {
      margin: 0;
      color: #7f1a54;
      width: 18px;
      min-width: 18px;
    }
  }

  &__footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    span {
      font-size: 16px;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .md-icon {
      margin: 0;
      color: #7a7a7a;
      width: 18px;
      min-width: 18px;
    }
  }

  .title-bold {
    font-weight: 600;
  }

  p,
  .title-bold {
    color: #666666;
    font-size: 14px !important;
  }

  .space {
    display: block;
    padding: 4px 0;
  }
}

.flex-column {
  display: flex;
  flex-direction: column;
}
</style>
